import _omit from 'lodash/omit';

import {
  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
  ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST:
    case ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS:
      return null;

    case ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
